module.exports = __webpack_public_path__ + "static/media/result-2-zh-CN.fca37297.png";